import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Payment } from '@app/finance/payments/payment.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/payments', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((payment: any) => {
          return new Payment().deserialize(payment);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(payment: Payment): Observable<Payment> {
    return this.http.put('v1/payments/' + payment.id, payment).pipe(
      map((response: HttpResponse) => {
        return new Payment().deserialize(response.data);
      })
    );
  }

  store(payment: Payment): Observable<Payment> {
    return this.http.post('v1/payments', payment).pipe(
      map((response: HttpResponse) => {
        return new Payment().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/payments/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Payment().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/payments/' + id);
  }
}
